export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-636_tn.cb72f886.jpg";